import React from 'react';
import './Header.css';

const Header = () => {
  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          <div className="logo-section">
            <h1 className="church-name">GEMEINDE MPEV</h1>
            <p className="church-tagline">Ministère de la Parole, Esprit et Vie</p>
            <p className="church-subtitle">Ministry Word, Spirit & Life</p>
            <p className="church-subtitle">Gemeinde des Wort, Geist und Leben</p>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
